import { combineEpics } from 'redux-observable';

import instanceEpics from './instance/epics';
import machineAccountsEpics from './machineAccounts/epics';
import productMembersEpics from './productMembers/epics';
import productsEpics from './products/epics';
import productTypeMembersEpics from './productTypeMembers/epics';
import productTypesEpics from './productTypes/epics';
import rolesEpics from './roles/epics';
import usersEpics from './users/epics';

export default combineEpics(
  instanceEpics,
  usersEpics,
  machineAccountsEpics,
  rolesEpics,
  productTypesEpics,
  productTypeMembersEpics,
  productsEpics,
  productMembersEpics
);
